import { TextField, TextFieldProps } from '@mui/material';
import { ChangeEvent } from 'react';

type DateInputProps = Omit<TextFieldProps, 'type' | 'onChange'> & {
  onChange: (event: ChangeEvent<HTMLInputElement>, value: Date) => void;
};

const DateInput = ({ onChange, disabled, ...props }: DateInputProps & {disabled: boolean}) => {
  const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange && onChange(event, new Date(event.target.value));
  };

  return <TextField {...props} onChange={handleOnChange} type="date" disabled={disabled} />;
};
export default DateInput;
